import React from 'react';
import { ThemeProvider } from '../../../contexts/ThemeContext';
import { CallsScreen } from '../../../pages/CallsScreen';
const PHONE_WIDTH = 390;
const PHONE_HEIGHT = 844;
const SCALE = 0.53;

/**
 * A live, non-interactive render of the real Vexu AI calls screen inside a
 * device frame — the same UI that opens full-screen from this panel.
 * `initialCallId` seeds the call history so the preview shows real content.
 */
export function VexuAppPreview() {
  return <div className="relative flex h-full w-full items-start justify-center pt-[26px]" data-id="element-539" data-mp="3tk1paq8jiyib">
      <div style={{
      width: PHONE_WIDTH * SCALE,
      height: PHONE_HEIGHT * SCALE
    }} className="relative rounded-[24px] border-[5px] border-[#e8e8e6] bg-[#e8e8e6] shadow-[0_26px_60px_-24px_rgba(15,23,42,0.45)] ring-1 ring-slate-900/[0.06]" data-id="element-540" data-mp="3ol8ej5kn1llu">
        <div className="absolute inset-0 overflow-hidden rounded-[19px] bg-white" data-id="element-541" data-mp="39wm0r8ant1wq">
          <div aria-hidden="true" style={{
          width: PHONE_WIDTH,
          height: PHONE_HEIGHT,
          transform: `scale(${SCALE})`,
          transformOrigin: 'top left'
        }} className="pointer-events-none select-none" data-id="element-542" data-mp="35wbtztf1m7gt">
            <ThemeProvider data-id="element-543" data-mp="3hu5s7lzcaqel">
              <div className="app-gradient-bg-light h-full w-full overflow-hidden pt-[10px]" data-id="element-544" data-mp="3msh21wpmx0wt">
                <CallsScreen onNavigate={() => undefined} initialCallId={-1} data-id="element-545" data-mp="3mubbadrjn4l2" />
              </div>
            </ThemeProvider>
          </div>
        </div>
        <div className="absolute left-1/2 top-[6px] h-[16px] w-[56px] -translate-x-1/2 rounded-full bg-black" data-id="element-546" data-mp="2z2w4o8sqi140" />
      </div>
    </div>;
}